import Gravity from 'Gravity';

const teamMembersWithPopUpClass = 'gg-team-members-flip-cards';
const teamMembersWithPopUpClassModules = document.querySelectorAll(`.${teamMembersWithPopUpClass}`);

const addActionsToPopupButtons = (module) => {
    const resultContainerClass = 'posts-result__container';
    const popUp = module.querySelector(`.${teamMembersWithPopUpClass}__popup`);
    const dynamicBoxes = module.querySelector('.gravity-block-dynamic-boxes');
    const closeButton = module.querySelector(`.${teamMembersWithPopUpClass}__popup-close > a`);
    const popUpDynamicBoxes = module.querySelector(`.${teamMembersWithPopUpClass}__popup .gravity-block-dynamic-boxes`);
    const popUpResultsContainer = popUpDynamicBoxes.querySelector(`.${resultContainerClass}`);
    let currentOpenButton = null;

    if (!popUp || !dynamicBoxes || !closeButton || !popUpDynamicBoxes) {
        return;
    }

    const popupTrapFocusHandler = (event) => {
        if (event.key === 'Tab') {
            closeButton.focus();
            event.preventDefault();
        }
    };

    const openPopUp = ({ target }) => {
        const postId = target.closest('.gravity-block-dynamic-boxes__box').getAttribute('data-post-id');

        if (!postId) {
            return;
        }

        module.classList.add('show-popup');
        Gravity.toggleBodyOverflow();
        updateMemberInfo(postId);
        currentOpenButton = target;

        document.addEventListener('keydown', popupTrapFocusHandler);
    };

    const closePopUp = () => {
        module.classList.remove('show-popup');
        Gravity.toggleBodyOverflow();
        document.removeEventListener('keydown', popupTrapFocusHandler);

        closeButton.addEventListener(
            'focusout',
            () => {
                if (document.body.classList.contains('user-is-tabbing')) {
                    currentOpenButton.focus();
                }
            },
            { once: true }
        );
    };

    const updateMemberInfo = (postId) => {
        popUpResultsContainer.innerHTML = null;
        popUpDynamicBoxes.classList.add('is-loading');

        getTeamMemberInfo(popUpDynamicBoxes, postId).then((response) => {
            if (!response.success || !response.data.html) {
                return;
            }

            popUpDynamicBoxes.classList.remove('is-loading');
            popUpResultsContainer.innerHTML = response.data.html;
        });
    };

    const getTeamMemberInfo = async (dynamicBoxesBlock, postId) => {
        // eslint-disable-next-line consistent-return

        if (dynamicBoxesBlock) {
            const blockSettings = dynamicBoxesBlock.dataset.blockSettings || null;
            const blockArgs = JSON.stringify({
                p: postId,
                post_status: 'publish',
                posts_per_page: '1',
                post_type: 'team',
            });

            const formData = new FormData();
            formData.append('action', 'filter_dynamic_box');
            formData.append('nonce', window.gravityBlocksGlobalVars.nonce);
            formData.append('blockArgs', blockArgs);
            formData.append('blockSettings', blockSettings);
            formData.append('paged', 1);
            formData.append('post_id', window.gravityBlocksGlobalVars.postId);

            try {
                const response = await fetch(window.gravityBlocksGlobalVars.ajaxUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                });

                // eslint-disable-next-line consistent-return
                return response.json();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
        return false;
    };

    // Add event listeners to: mouse click, Enter
    Gravity.clickEnterListener(closeButton, closePopUp);

    const addActionToOpenButtons = () => {
        const openButtons = module.querySelectorAll(`.${teamMembersWithPopUpClass}__open-popup`);
        openButtons.forEach((button) => {
            button.addEventListener('click', openPopUp);
        });
    };
    addActionToOpenButtons();

    // support for boxes change (Filters/ Load More)
    dynamicBoxes.addEventListener('gg-boxes-loaded', () => {
        addActionToOpenButtons();
    });
};

Gravity.ready(() => {
    teamMembersWithPopUpClassModules.forEach((module) => {
        addActionsToPopupButtons(module);
    });
});
